"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPerformanceObserver = createPerformanceObserver;

function createPerformanceObserver(type, callback) {
  if (!PerformanceObserver.supportedEntryTypes.includes(type)) {
    throw new Error("The entry type ".concat(type, " does not exist or is not supported."));
  }

  var observer = new PerformanceObserver(function (list) {
    list.getEntries().forEach(callback);
  });
  observer.observe({
    buffered: true,
    type: type
  });
  return observer;
}